import React, { useRef } from 'react';
import type { UnregisterCallback } from 'history';
import { history } from 'instantsearch.js/es/lib/routers';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../components';
import useLayoutVariables from '../../hooks/useLayoutVariables';

import './style.scss';

const Search = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'pages.search' });

  const routerHistory = useHistory();
  const removeHistoryListener = useRef<UnregisterCallback>();

  const routing = {
    router: history({
      start: (onUpdate) => {
        removeHistoryListener.current = routerHistory.listen(onUpdate);
      },
      dispose: () => removeHistoryListener.current,
    }),
  };

  const {
    hitsPerPage,
    textColClasses,
    facetColClasses,
    resultsColClasses,
  } = useLayoutVariables('searchPage');

  return (
    <div className="Search">
      <SearchAllContent {...{ routing, hitsPerPage }}>
        <div className="Search__hero">
          <Container>
            <div className="row">
              <div className={textColClasses}>
                <div className="Search__hero__text-wrapper">
                  <div className="Search__hero__text">
                    <h1 className="Search__title">
                      {t('title')}
                    </h1>

                    <p className="Search__body body--large">
                      {t('body')}
                    </p>
                  </div>

                  <SearchAllContent.SearchBar />
                </div>
              </div>
            </div>
          </Container>
        </div>

        <div className="Search__content">
          <Container>
            <div className="row">
              <div className={facetColClasses}>
                <SearchAllContent.Facets />
              </div>

              <div className={resultsColClasses}>
                <div className="Search__stats">
                  <SearchAllContent.Stats />
                  <SearchAllContent.SortBy />
                </div>

                <SearchAllContent.Results />
              </div>
            </div>
          </Container>
        </div>
      </SearchAllContent>
    </div>
  );
};

export default Search;
